import { uiRows } from './types-def.js';
/** `web/sessions` (2.D): Tonight and the run sheet. */
export const SESSIONS_INTERACTIONS = uiRows([
    {
        id: 'sessions.runsheet.drag',
        module: 'web/sessions',
        behavior: 'Documents, scene headings and secrets dragged into the run sheet become items in order',
        owner: '2.D',
        since: 'exit-2b',
    },
    {
        id: 'sessions.prep.mark-ready',
        module: 'web/sessions',
        behavior: '"Mark prepped" sets the session to prepped',
        owner: '2.D',
        since: 'exit-2b',
    },
    // CS r5a deliverable 149: every Tonight and run-sheet action by a visible control (DECISIONS 161).
    {
        id: 'sessions.tonight.open',
        module: 'web/sessions',
        behavior: '"Tonight" in the sidebar and on Home opens Tonight for the next session',
        owner: '2.D',
        since: 'exit-2b',
    },
    {
        id: 'sessions.session.new',
        module: 'web/sessions',
        behavior: '"New session" on Tonight creates the next session and shows it',
        owner: '2.D',
        since: 'exit-2b',
    },
    {
        id: 'sessions.attendance.toggle',
        module: 'web/sessions',
        behavior: "Each player character's checkbox marks them present or absent",
        owner: '2.D',
        since: 'exit-2b',
    },
    {
        id: 'sessions.runsheet.add',
        module: 'web/sessions',
        behavior: '"Add to run sheet" opens a picker of pages, scene headings and secrets, and adds the choice',
        owner: '2.D',
        since: 'exit-2b',
    },
    {
        id: 'sessions.runsheet.edit',
        module: 'web/sessions',
        behavior: "An item's planned note and minutes are edited in place, and the total follows",
        owner: '2.D',
        since: 'exit-2b',
    },
    {
        id: 'sessions.session.start',
        module: 'web/sessions',
        behavior: '"Start session" shows the session number, editable, and starts the session',
        owner: '2.D',
        since: 'exit-2b',
    },
    {
        id: 'sessions.runsheet.move',
        module: 'web/sessions',
        behavior: 'An item moves by its handle, and by its Move up and Move down buttons',
        owner: '2.D',
        since: 'exit-2b',
    },
]);
//# sourceMappingURL=sessions.js.map